import { useEffect, useState } from "react";

export default function Admin() {
  const API = "https://pbplushservice.com/formapi.php";

  const emptyForm = {
    name: "",
    fathername: "no",
    dob: "",
    address: "",
    state: "",
    mobile: "",
    email: "",
    password: "",
    finance_bank: "",
    loan_amount: "",
    year: "",
    emi: "",
    interest_rate: "",
    loan_processing_fee: "",
    bank_name: "",
    ac_no: "",
    ifsc_code: "",
    branch_name: "",
    branch_address: "",
    note: "",
  };

  const [form, setForm] = useState(emptyForm);
  const [users, setUsers] = useState([]);
  const [editId, setEditId] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const loadUsers = async () => {
    const res = await fetch(`${API}?action=read`);
    const data = await res.json();
    setUsers(data);
    console.log(data)
  };

  useEffect(() => {
    loadUsers();
  }, []);

const submitForm = async (e) => {
  e.preventDefault();

  const action = editId ? "update" : "create";

  const payload = editId
    ? {
        ...form,
        id: editId,
        ...(form.password === "" && { password: undefined }),
      }
    : {
        ...form,
        fathername: "no",
      };

  await fetch(`${API}?action=${action}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  setForm(emptyForm);
  setEditId(null);
  loadUsers();
};


  const editUser = (user) => {
    setForm({ ...user, password: "" });
    setEditId(user.id);
  };

  const deleteUser = async (id) => {
    if (!window.confirm("Delete this user?")) return;

    await fetch(`${API}?action=delete`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });

    loadUsers();
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: "center" }}>
        {editId ? "Update User" : "Create User"}
      </h2>

      <form onSubmit={submitForm} style={formStyle}>
        {Object.keys(emptyForm).map(
          (key) =>
              key !== "password" &&
    key !== "note" &&
    key !== "fathername" &&  (
              <div class="formlabeldiv" key={key}>
                <input
                  type={
                    key === "dob"
                      ? "date"
                      : ["loan_amount","year","emi","interest_rate","loan_processing_fee"].includes(key)
                      ? "number"
                      : key === "email"
                      ? "email"
                      : "text"
                  }
                  name={key}
                  value={form[key]}
                  onChange={handleChange}
                />
                <label>{   key === "dob"
                      ? "DATE"
                      : key.replaceAll("_", " ").toUpperCase()}</label>
              </div>
            )
        )}

{editId && (
  <div className="formlabeldiv">
    <input
      type="password"
      name="password"
      value={form.password}
      onChange={handleChange}
      placeholder="New Password"
    />
    <label>New Password</label>
  </div>
)}

        <div className="formlabeldiv" style={{ width: "100%" }}>
          <textarea
            name="note"
            value={form.note}
            onChange={handleChange}
            rows="5"
            placeholder="Note"
          />
        </div>

        <button type="submit">
          {editId ? "Update" : "Submit"}
        </button>
      </form>

      <hr />
  <div className="table-div" style={{ marginTop: "20px" }}>
      <table border="1" width="100%">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Date</th>
              <th>Address</th>
              <th>Email</th>
                 <th>password</th>
              <th>State</th>
              <th>Mobile</th>
              <th>Finance Bank</th>
              <th>Loan Amount</th>
              <th>Year</th>
              <th>EMI</th>
              <th>Interest Rate</th>
              <th>Processing Fee</th>
              <th>Branch Name</th>
              <th>AC No</th>
              <th>IFSC</th>
              <th>Branch Address</th>
              <th>Note</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.id}</td>
                <td>{u.name}</td>
                <td>{u.dob}</td>
                <td>{u.address}</td>
                <td>{u.email}</td>
                    <td>{u.password}</td>
                <td>{u.state}</td>
                <td>{u.mobile}</td>
                <td>{u.finance_bank}</td>
                <td>{u.loan_amount}</td>
                <td>{u.year}</td>
                <td>{u.emi}</td>
                <td>{u.interest_rate}</td>
                <td>{u.loan_processing_fee}</td>
                <td>{u.branch_name}</td>
                <td>{u.ac_no}</td>
                <td>{u.ifsc_code}</td>
                <td>{u.branch_address}</td>
                <td>{u.note}</td>
                <td>
                  <button onClick={() => editUser(u)}>Edit</button>
                </td>
                <td>
                  <button onClick={() => deleteUser(u.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
      </table>

  </div>

    </div>
  );
}


/* ===== styles ===== */
const containerStyle = {
  padding: "30px",
  backgroundColor: "white",
  maxWidth: "1000px",
  width: "90%",
  borderRadius: "10px",
  margin: "30px auto",
};

const formStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
};
